import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { acceptInvite, rejectInvite, showInviteeMenu } from '../../store/EventStore';
import config from '../../config';
import eventAcceptImage from '../../images/event_accept.png';
import eventRejectImage from '../../images/event_reject.png';

const Invitee = ({ eventInvitation }) => {
    const dispatch = useDispatch();

    const personsMap = useSelector((state) => state.personState.persons);
    const shouldShowInviteeMenu = useSelector((state) => state.eventState.showInviteeMenu);

    const person = personsMap[eventInvitation.personId];
    if (!person) return null;

    const handleAcceptInvite = () => {
        dispatch(acceptInvite({invitationId: eventInvitation.id}));
    };

    const handleRejectInvite = () => {
        dispatch(rejectInvite({invitationId: eventInvitation.id}));
    };

    const handleToggleInviteeMenu = () => {
        dispatch(showInviteeMenu({ show: shouldShowInviteeMenu !== person.id, personId: person.id }));    
    };

    const renderResponseForm = () => {
        return (
            <div className="invitee-menu">
                <img className="accept-image" src={eventAcceptImage} alt="" />
                <div className="accept-text" onClick={handleAcceptInvite}>
                    Tilmeld
                </div>
                <img className="reject-image" src={eventRejectImage} alt="" />
                <div className="reject-text" onClick={handleRejectInvite}>
                    Afslå
                </div>
            </div>
        );
    };

    return (
        <div className="invitee" onClick={handleToggleInviteeMenu}>
            <img src={`${config.server}/${person.imagePath}`} alt="Person billede" />
            <div className="invitee-name">{person.name}</div>
            {shouldShowInviteeMenu === person.id && renderResponseForm()}
        </div>
    );
};

Invitee.propTypes = {
    eventInvitation: PropTypes.object.isRequired,
};

export default Invitee;